import chromajs from 'chroma-js';
import hueName from '../utils/hue-name';

export const useColorSystem = ({
  colorSchemePreference = 'light',
  hueOffset = 0,
  numberOfHues = 9,
  hues = new Array(numberOfHues)
    .fill()
    .map((_, x) => (x * 360) / numberOfHues + hueOffset),
  scaleLength = 10,
  scale = new Array(scaleLength).fill().map((_, x) => x),
  getChroma = x =>
    100 - ((Math.sin(((Math.PI / 2) * x) / scaleLength) + 1) / 2) * 100 * 0.8,
  luminanceRange = 70,

  getLuminance = x => {
    if (colorSchemePreference === 'inverted') {
      x = scaleLength - 1 - x;
    }

    const offset = colorSchemePreference === 'dark' ? 0 : 100 - luminanceRange;
    return (
      Math.sin(((Math.PI / 2) * x) / scaleLength) * luminanceRange + offset
    );
  }
} = {}) => {
  return hues.reduce(
    (colors, hue) => {
      colors[hueName(hue)] = scale.map(x =>
        chromajs.hcl(hue, getChroma(x, hue), getLuminance(x, hue)).hex()
      );
      return colors;
    },
    {
      gray: scale.map(x => chromajs.hcl(undefined, 0, getLuminance(x)).hex())
    }
  );
};

export default useColorSystem;
